export const enum CommonTrackingEvent {
  COPY_SHAREABLE_LINK_CLICKED = 'copy-shareable-link-clicked',
  COPY_TO_NEW_SELECTION = 'copy-to-new-selection-clicked',
  UNIT_SWITCHER_CLICKED = 'unit-switcher-clicked',
}
